import { render, staticRenderFns } from "./UserSelectItem.vue?vue&type=template&id=62aaf9f6&scoped=true&lang=html&"
import script from "./UserSelectItem.vue?vue&type=script&lang=js&"
export * from "./UserSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectItem.vue?vue&type=style&index=0&id=62aaf9f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aaf9f6",
  null
  
)

export default component.exports